"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// eslint-disable-next-line no-unused-vars
var _default = theme => ({
  tableBody: {
    '& > .scTableRowContainer:last-child .scTableRowDivider': {
      display: 'none'
    }
  }
});
exports.default = _default;